<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CheckEmptyScriptTag -->
<template>
  <v-app>

    <v-navigation-drawer fixed permanent expand-on-hover touchless>
      <v-list-item>
        <v-list-item-icon id="circular-icon">
          t
        </v-list-item-icon>
      </v-list-item>

      <v-divider />

      <v-list dense nav >
        <v-list-item link to="/">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/projects">
          <v-list-item-icon>
            <v-icon>mdi-xml</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Work Outside of Work</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/suhc">
          <v-list-item-icon>
            <img :src="require('./assets/icons/suhc.png')" />
          </v-list-item-icon>
          <v-list-item-title>SUHC</v-list-item-title>
        </v-list-item>

        <!-- TODO v-list-group -->
        <v-list dense nav>
          <v-list-item link to="/suhc/log">
            <v-list-item-icon>
              <v-icon class="move-icon-left">mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Captain's log</v-list-item-title>
          </v-list-item>

          <v-list-item link to="/suhc/quotes">
            <v-list-item-icon>
              <v-icon class="move-icon-left">mdi-menu-right</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Quotes Collection</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list-item link to="/a" v-if="activeComponents.includes('A')">
          <v-list-item-icon>
            <v-icon>mdi-download</v-icon>
          </v-list-item-icon>
          <v-list-item-title>A</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/goldmine" v-if="activeComponents.includes('Goldmine')">
          <v-list-item-icon>
            <v-icon>mdi-emoticon-excited</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Gold mine</v-list-item-title>
        </v-list-item>

        <v-list-item link to="/l">
          <v-list-item-icon>
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Literature</v-list-item-title>
        </v-list-item>

        <v-list dense nav v-if="activeComponents.includes('L')">
          <v-list-item link to="/l/admin" v-if="activeComponents.includes('LA')">
            <v-list-item-icon>
              <v-icon>mdi-wrench</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Administrare Literatură</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-list-item link to="/contact">
          <v-list-item-icon>
            <v-icon>mdi-email</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Contact</v-list-item-title>
        </v-list-item>

        <PopupTrigger v-if="activeComponents.includes('Login')"
                      pathFromBackend="/login"
                      icon="mdi-account"
                      text="Login" />

        <PopupTrigger v-if="activeComponents.includes('Logout')"
                      pathFromBackend="/logout"
                      icon="mdi-lock"
                      :text="'Logout ' + userId" />

        <v-list-item v-if="!!restCallsGoing">
          <v-progress-circular indeterminate />
        </v-list-item>

        <v-divider v-if="!!alerts.length" style="margin-top: 49px" />
        <v-list-item v-if="!!alerts.length">
          <v-list-item-icon>
            <v-icon>mdi-alert</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: orange">Backend unreachable.<br>Limited functionality</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main style="padding-left: 56px">
      <header>
        <div class="container">
          <span style="float:right; margin: -10px 0;">
            <v-icon @click="lightTheme = false">mdi-moon-waning-crescent</v-icon>
            <v-switch v-model="lightTheme" class="floatingToggle" />
            <v-icon @click="lightTheme = true">mdi-weather-sunny</v-icon>
          </span>

          <h1>{{$interpretedHost}}</h1>
        </div>
      </header>

      <router-view :uploadVisible="activeComponents.includes('U')"
                   :userId="userId" />
    </v-main>
  </v-app>
</template>

<script>
import AxiosHelper from './components/AxiosHelper.vue';
import PopupTrigger from './components/PopupTrigger.vue';

export default {
  name: 'App',
  components: {PopupTrigger},
  mixins: [AxiosHelper],

  data: () => ({
    lightTheme: false,

    userId: null,
    activeComponents: []
  }),

  watch: {
    lightTheme: function(light) {
      this.$vuetify.theme.dark = !light;
    }
  },

  methods: {
    setUserInfo(userInfo) {
      this.userId = userInfo.userId;
      this.activeComponents = userInfo.activeComponents;
    }
  },

  mounted () {
    this.credentialedAxios('fetching active components', axios => axios.get(this.$apiUrl + '/userInfo'),
      data => this.setUserInfo(data));
  }
};
</script>
<style>
  .floatingToggle {
    display: inline-block !important;
    vertical-align: middle;
  }
  /* Class internal to Vue */
  /* noinspection CssUnusedSymbol */
  .mdi-alert::before {
    color: orangered;
  }
</style>
